import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// types
import { TSidebarProjectItems } from 'pages/all-projects-dashboard/types';

export interface IAllProjectsSlice {
  selectedProjectsList: TSidebarProjectItems[];
}

const initialState: IAllProjectsSlice = {
  selectedProjectsList: null,
};

export const allProjectsSlice = createSlice({
  name: 'all-projects',
  initialState,
  reducers: {
    setAllProjectsList: (state, action: PayloadAction<TSidebarProjectItems[]>) => {
      state.selectedProjectsList = action.payload;
    },
  },
});

export const { setAllProjectsList } = allProjectsSlice.actions;

export default allProjectsSlice.reducer;
